import { createStore } from "vuex"

import router from "@/router"
let localeUinfo = localStorage.getItem("userInfoCallCenter") || null
let localeAdminInfo = localStorage.getItem("adminInfoCallCenter") || null

let localMenuList = localStorage.getItem("menuList") || null

let offsetWid = document.documentElement.clientWidth
let isBingWin = offsetWid >= 900
export default createStore({
    state: {
        userInfo: localeUinfo ? JSON.parse(localeUinfo) : {},
        adminInfo: localeAdminInfo ? JSON.parse(localeAdminInfo) : {},
        isLoading: false,
        // permissionList: ['china'],
        isBigWin: isBingWin,
        menuList: localMenuList || [],
    },
    getters: {
        userInfo(state) {
            return state.userInfo
        },
        adminInfo(state) {
            return state.adminInfo
        },
        hasLogin(state) {
            if (typeof state.userInfo === "object" && Object.keys(state.userInfo).length > 0) {
                return true
            } else {
                return false
            }
        },
        authToken: (state) => {
            if (Object.keys(state.userInfo || {}).length < 1) return ""
            return state.userInfo?.accessToken || ""
        },
        isSuperAdmin: (state) => {
            return state.userInfo?.super == true
        },
        isKazakhstanPhone: (state) => {
            return state.userInfo?.phone?.startsWith("+7")
        },
        countyByPhone: (state) => {
            const phone = state.userInfo?.phone
            if (!phone) return null

            if (phone.startsWith("+7")) return "KZ"
            if (phone.startsWith("+998")) return "UZ"
            if (phone.startsWith("+996")) return "KG"
            if (phone.startsWith("+992")) return "TJ"
            if (phone.startsWith("+976")) return "MN"
            if (phone.startsWith("+86")) return "ZH"

            return null
        },
    },
    mutations: {
        async setUserInfo(state, e) {
            let info = e
            if (typeof e == "object") {
                state.userInfo = { ...info }
                localStorage.setItem("userInfoCallCenter", JSON.stringify(state.userInfo))
            }
        },
        updateUserInfo(state, e) {
            let info = e
            if (typeof e == "object") {
                state.userInfo = { ...state.userInfo, ...info }
                localStorage.setItem("userInfoCallCenter", JSON.stringify(state.userInfo))
            }
        },
        async setAdminInfo(state, e) {
            let info = e
            if (typeof e == "object") {
                state.adminInfo = { ...info }
                localStorage.setItem("adminInfoCallCenter", JSON.stringify(state.adminInfo))
            }
        },
        async updateAdminInfo(state, e) {
            let info = e
            if (typeof e == "object") {
                state.adminInfo = { ...state.adminInfo, ...info }
                localStorage.setItem("adminInfoCallCenter", JSON.stringify(state.adminInfo))
            }
        },
        setMenuList(state, e) {
            let info = e
            if (typeof e == "object") {
                state.menuList = info
                localStorage.setItem("menuList", state.menuList)
            }
        },
        setLoading(state, e) {
            state.isLoading = Boolean(e)
        },
        signOut(state) {
            state.userInfo = {}
            localStorage.removeItem("userInfoCallCenter")
            localStorage.removeItem("adminInfoCallCenter")
            router.push({
                name: "LoginView",
            })
        },
        updateMenuOpenKeys(state, e) {
            if (!e.type) return
            if (e.type == "push") {
                state.menuOpenKeys.push(e.data)
            } else if (e.type == "delete") {
                state.menuOpenKeys.splice(e.index, 1)
            }
        },
        setTempStore(state, info) {
            if (typeof info == "object") {
                return (state.tempStore = {
                    ...state.tempStore,
                    ...info,
                })
            }
        },
    },
    actions: {},
    modules: {},
})
